export default (patient = {}) => {
  return Object.assign({
    id: '',
    resourceType: 'Patient',
    display: '',
    reference: '',
    birthDate: null,
    email : '',
    name: {
      family: '',
      given: ''
    },
    address: {
      text: '',
      state: '',
      district: ''
    },
    contact: [
      {
        relationship: [],
        id: '',
        birthDate: '',
        name: {
          family: '',
          given: ''
        }
      }
    ]
  }, patient);
};
